import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import UsersPanelNarrow from '../containers/UsersPanelNarrow';
import UsersPanelFull from '../containers/UsersPanelFull';

const UsersPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: UsersPanelFull, narrow: UsersPanelNarrow }}
    width={560}
  />
);

export default UsersPanel;
